import debounce from './debounce';

export default function onResize(callback) {
    window.addEventListener('resize', debounce(callback, 300));
}
